function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.49115 5.95743C7.54499 3.35938 10.1846 0.901855 14.1225 0.901855C18.3592 0.901855 21.9701 3.7845 22.7618 8.44938C23.8796 8.6167 25.05 9.04483 26.0138 9.76072C27.2116 10.6505 28.108 12.0063 28.108 13.8166C28.108 15.5719 27.369 16.9683 26.1659 17.9043C24.9865 18.8219 23.4169 19.2578 21.7708 19.2578H17.6189C17.1361 19.2578 16.7448 18.8665 16.7448 18.3838C16.7448 17.901 17.1361 17.5097 17.6189 17.5097H21.7708C23.1295 17.5097 24.2914 17.1477 25.0924 16.5246C25.8696 15.9199 26.3598 15.0327 26.3598 13.8166C26.3598 12.6556 25.8085 11.786 24.9713 11.1641C24.1126 10.5262 22.9745 10.1734 21.9461 10.1225C21.5155 10.1012 21.1648 9.76909 21.12 9.34032C20.6796 5.12669 17.6511 2.65005 14.1225 2.65005C10.7904 2.65005 8.6601 4.84818 7.96208 7.02517C7.85533 7.35811 7.56045 7.5954 7.21239 7.62847C4.20028 7.91462 1.88515 9.76898 1.88515 12.571C1.88515 15.388 4.31925 17.5097 7.56677 17.5097H10.6261C11.1089 17.5097 11.5002 17.901 11.5002 18.3838C11.5002 18.8665 11.1089 19.2578 10.6261 19.2578H7.56677C3.60301 19.2578 0.136963 16.5851 0.136963 12.571C0.136963 8.75342 3.15942 6.47266 6.49115 5.95743Z",
  fill: "#0460A9"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.7408 8.15067C14.3994 7.80931 13.8459 7.80931 13.5046 8.15067L10.0082 11.647C9.66686 11.9884 9.66686 12.5419 10.0082 12.8832C10.3496 13.2246 10.903 13.2246 11.2444 12.8832L13.2484 10.8792V22.7772C13.2484 23.26 13.6398 23.6513 14.1225 23.6513C14.6053 23.6513 14.9966 23.26 14.9966 22.7772V10.8788L17.001 12.8832C17.3423 13.2246 17.8958 13.2246 18.2371 12.8832C18.5785 12.5419 18.5785 11.9884 18.2371 11.647L14.7408 8.15067Z",
  fill: "#0460A9"
});

var SvgUpload = function SvgUpload(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload.15514c41.svg";
export { ForwardRef as ReactComponent };